import { countDecimals } from '@ringo/shared'
import Input from './input'

export type InputNumberProps = {
    label?: string
    hideLabel?: boolean
    required?: boolean
    step: string
    unit?: string
    disabled?: boolean
    error?: { key: string; values: object }
    info?: string
    value: number | null
    onChange?: (value: number | null) => void
    onBlur?: () => void
    min?: number
    max?: number
    maxDecimalPlaces?: number
    inputClassName?: string
}

const InputNumber = ({
    label,
    hideLabel,
    required,
    step,
    unit,
    error,
    info,
    value,
    disabled,
    onChange,
    onBlur,
    min = -99999,
    max = 99999,
    maxDecimalPlaces,
    inputClassName,
}: InputNumberProps) => {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value
        const numericValue = parseFloat(inputValue)

        const maxMinConstraintsValid = max && Number(event.target.value) <= max && min && Number(event.target.value) >= min

        if (!maxMinConstraintsValid) {
            return
        }

        if (numericValue && maxDecimalPlaces != null && countDecimals(numericValue) > maxDecimalPlaces) {
            onChange && onChange(parseFloat(numericValue.toFixed(maxDecimalPlaces)))
        } else {
            onChange && onChange(inputValue ? numericValue : null)
        }
    }

    return (
        <div className="relative">
            <Input label={label ?? ''} hideLabel={hideLabel} error={error} info={info} required={required}>
                <div className="relative">
                    <input
                        value={value as any}
                        type="number"
                        className={`number-input ${disabled ? 'bg-gray-200!' : ''} ${inputClassName || ''}`}
                        step={step}
                        onBlur={onBlur}
                        onChange={handleInputChange}
                        disabled={disabled}
                    />
                    {unit && (
                        <p className="absolute top-1/2 right-0 text-sm transform -translate-x-1/2 -translate-y-1/2 leading-none! text-gray-500 max-tablet:text-xs max-tablet:right-[19%] pointer-events-none">
                            {unit}
                        </p>
                    )}
                </div>
            </Input>
        </div>
    )
}

export default InputNumber
